<template>
    <div>
        <div v-if="isServiceProduct" class="form-group form-select form-group-floating-label">
            <select
                id="input-selected_service_supplier_id"
                name="supplier_id"
                class="form-input"
                @change="selectServiceSupplierId"
            >
                <option value="">Välj avtalspart</option>
                <option
                    v-for="supplier in suppliers"
                    :value="supplier.id"
                    :selected="selected_service_supplier_id == supplier.id"
                >
                    {{ supplier.name }}
                </option>
            </select>
            <label for="input-selected_service_supplier_id" class="floating-label">
                Avtalspart tjänst(er)
            </label>
            <select-arrow />
            <span v-if="errorServiceSupplierId" class="form-error">
                {{ errorServiceSupplierId }}
            </span>
        </div>

        <div class="form-group form-select form-group-floating-label">
            <select
                id="input-selected_credit_supplier_id"
                name="credit_supplier_id"
                class="form-input"
                @change="selectCreditSupplierId"
            >
                <option value="">Välj avtalspart</option>
                <option
                    v-for="supplier in suppliers"
                    :value="supplier.id"
                    :selected="selected_credit_supplier_id == supplier.id"
                >
                    {{ supplier.name }}
                </option>
            </select>
            <label for="input-selected_credit_supplier_id" class="floating-label">
                Avtalspart kreditavtal
            </label>
            <select-arrow />
            <span v-if="errorCreditSupplierId" class="form-error">
                {{ errorCreditSupplierId }}
            </span>
        </div>

        <div class="form-group form-select form-group-floating-label">
            <select
                id="input-selected_operations_supplier_id"
                name="operations_supplier_id"
                class="form-input"
                @change="selectOperationsSupplierId"
            >
                <option value="">Välj avtalspart</option>
                <option
                    v-for="supplier in suppliers"
                    :value="supplier.id"
                    :selected="selected_operations_supplier_id == supplier.id"
                >
                    {{ supplier.name }}
                </option>
            </select>
            <label for="input-selected_operations_supplier_id" class="floating-label">
                Avtalspart driftavtal
            </label>
            <select-arrow />
            <span v-if="errorOperationsSupplierId" class="form-error">
                {{ errorOperationsSupplierId }}
            </span>
        </div>

        <div class="grid">
            <div v-if="isServiceProduct" class="column w-full md:w-1/2">
                <div class="form-group form-select form-group-floating-label">
                    <select
                        id="input-service_supplier_terms_id"
                        v-model="service_supplier_id"
                        name="service_supplier_terms_id"
                        class="form-input"
                        required
                    >
                        <option value="">Välj avtalstext</option>
                        <option
                            v-for="term in serviceTerms"
                            :value="term.id"
                        >
                            {{ term.name }}
                        </option>
                    </select>
                    <label for="input-service_supplier_terms_id" class="floating-label">
                        Avtalstext tjänst(er)
                    </label>
                    <select-arrow />
                    <span v-if="errorServiceSupplierTermsId" class="form-error">
                        {{ errorServiceSupplierTermsId }}
                    </span>
                </div>
            </div>
            <div
                class="column w-full"
                :class="{ 'md:w-1/2' : isServiceProduct }"
            >
                <div class="form-group form-select form-group-floating-label">
                    <select
                        id="input-installation_supplier_terms_id"
                        v-model="installation_supplier_id"
                        name="installation_supplier_terms_id"
                        class="form-input"
                        required
                    >
                        <option value="">Välj avtalstext</option>
                        <option
                            v-for="term in installationTerms"
                            :value="term.id"
                        >
                            {{ term.name }}
                        </option>
                    </select>
                    <label for="input-installation_supplier_terms_id" class="floating-label">
                        Avtalstext installation
                    </label>
                    <select-arrow />
                    <span v-if="errorInstallationSupplierTermsId" class="form-error">
                        {{ errorInstallationSupplierTermsId }}
                    </span>
                </div>
            </div>
            <div class="column w-full md:w-1/2">
                <div class="form-group form-select form-group-floating-label">
                    <select
                        id="input-credit_supplier_terms_id"
                        v-model="credit_supplier_id"
                        name="credit_supplier_terms_id"
                        class="form-input"
                        :required="selected_credit_supplier_id > 0"
                    >
                        <option value="">Välj avtalstext</option>
                        <option
                            v-for="term in creditTerms"
                            :value="term.id"
                        >
                            {{ term.name }}
                        </option>
                    </select>
                    <label for="input-credit_supplier_terms_id" class="floating-label">
                        Avtalstext kredit
                    </label>
                    <select-arrow />
                    <span v-if="errorCreditSupplierTermsId" class="form-error">
                        {{ errorCreditSupplierTermsId }}
                    </span>
                </div>
            </div>
            <div class="column w-full md:w-1/2">
                <div class="form-group form-select form-group-floating-label">
                    <select
                        id="input-operations_supplier_terms_id"
                        v-model="operations_supplier_id"
                        name="operations_supplier_terms_id"
                        class="form-input"
                        :required="selected_operations_supplier_id > 0"
                    >
                        <option value="">Välj avtalstext</option>
                        <option
                            v-for="term in operationsTerms"
                            :value="term.id"
                        >
                            {{ term.name }}
                        </option>
                    </select>
                    <label for="input-operations_supplier_terms_id" class="floating-label">
                        Avtalstext drift
                    </label>
                    <select-arrow />
                    <span v-if="errorOperationsSupplierTermsId" class="form-error">
                        {{ errorOperationsSupplierTermsId }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SelectArrow from '../../../../shared/components/Base/Forms/SelectArrow';

    export default {
        name: 'SupplierForm',

        components: {
            SelectArrow,
        },

        props: {
            suppliers: {
                type: Array,
                required: true,
            },
            supplierTerms: {
                type: Array,
                required: true,
            },
            selectedServiceSupplierId: {
                type: Number,
                default: null,
            },
            selectedCreditSupplierId: {
                type: Number,
                default: null,
            },
            selectedOperationsSupplierId: {
                type: Number,
                default: null,
            },
            serviceSupplierId: {
                type: Number,
                default: null,
            },
            installationSupplierId: {
                type: Number,
                default: null,
            },
            creditSupplierId: {
                type: Number,
                default: null,
            },
            operationsSupplierId: {
                type: Number,
                default: null,
            },
            isServiceProduct: {
                type: Boolean,
                default: false,
            },
            errorServiceSupplierId: {
                type: Number,
                default: null,
            },
            errorCreditSupplierId: {
                type: Number,
                default: null,
            },
            errorOperationsSupplierId: {
                type: Number,
                default: null,
            },
            errorServiceSupplierTermsId: {
                type: Number,
                default: null,
            },
            errorInstallationSupplierTermsId: {
                type: Number,
                default: null,
            },
            errorCreditSupplierTermsId: {
                type: Number,
                default: null,
            },
            errorOperationsSupplierTermsId: {
                type: Number,
                default: null,
            },
        },

        data() {
            return {
                selected_service_supplier_id: null,
                selected_credit_supplier_id: null,
                selected_operations_supplier_id: null,
                service_supplier_id: '',
                installation_supplier_id: '',
                credit_supplier_id: '',
                operations_supplier_id: '',
                serviceTerms: [],
                creditTerms: [],
                operationsTerms: [],
            };
        },

        computed: {
            installationTerms: function () {
                return this.supplierTerms.filter(term => term.supplier_id === this.snbSupplierId);
            },

            snbSupplierId: function () {
                const snbSupplier = this.suppliers.find(supplier => supplier.is_snb);

                return snbSupplier.id;
            },
        },

        watch: {
            'selected_service_supplier_id': function () {
                if (! this.selected_service_supplier_id) {
                    this.serviceTerms = [];
                    return;
                }

                this.serviceTerms = this.supplierTerms.filter(term => term.supplier_id === parseInt(this.selected_service_supplier_id));
            },

            'selected_credit_supplier_id': function () {
                if (! this.selected_credit_supplier_id) {
                    this.creditTerms = [];
                    return;
                }

                this.creditTerms = this.supplierTerms.filter(term => term.supplier_id === parseInt(this.selected_credit_supplier_id));
            },

            'selected_operations_supplier_id': function () {
                if (! this.selected_operations_supplier_id) {
                    this.operationsTerms = [];
                    return;
                }

                this.operationsTerms = this.supplierTerms.filter(term => term.supplier_id === parseInt(this.selected_operations_supplier_id));
            },
        },

        created() {
            this.selected_service_supplier_id = this.selectedServiceSupplierId;
            this.selected_credit_supplier_id = this.selectedCreditSupplierId;
            this.selected_operations_supplier_id = this.selectedOperationsSupplierId;
            this.service_supplier_id = this.serviceSupplierId;
            this.installation_supplier_id = this.installationSupplierId;
            this.credit_supplier_id = this.creditSupplierId;
            this.operations_supplier_id = this.operationsSupplierId;
        },

        methods: {
            selectServiceSupplierId: function (e) {
                const value = e.target.value;

                // Reset to empty string if selected_service_supplier_id was updated,
                // otherwise no option will be selected and it won't be included in the post data.
                if (this.selected_service_supplier_id !== value) {
                    this.selected_service_supplier_id = '';
                }

                this.selected_service_supplier_id = value;
            },

            selectCreditSupplierId: function (e) {
                const value = e.target.value;

                // Reset to empty string if selected_credit_supplier_id was updated,
                // otherwise no option will be selected and it won't be included in the post data.
                if (this.selected_credit_supplier_id !== value) {
                    this.selected_credit_supplier_id = '';
                }

                this.selected_credit_supplier_id = value;
            },

            selectOperationsSupplierId: function (e) {
                const value = e.target.value;

                // Reset to empty string if selected_operations_supplier_id was updated,
                // otherwise no option will be selected and it won't be included in the post data.
                if (this.selected_operations_supplier_id !== value) {
                    this.selected_operations_supplier_id = '';
                }

                this.selected_operations_supplier_id = value;
            },
        },
    };
</script>
